"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-3d-printing";

const IMAGE_BASE = "/image/new-version/more/3D-Printing/With-JS-Precision";

const CARDS = [
	{
		image: `${IMAGE_BASE}/sla-stereolithography-3d-printing-service.webp`,
		keyPrefix: "printingServicesOverviewCard1",
		href: "/sla-stereolithography",
	},
	{
		image: `${IMAGE_BASE}/mjf-multi-jet-fusion-3d-printing-service.webp`,
		keyPrefix: "printingServicesOverviewCard2",
		href: "/mjf-multi-jet-fusion",
	},
	{
		image: `${IMAGE_BASE}/sls-selective-laser-sintering-3d-printing-service.webp`,
		keyPrefix: "printingServicesOverviewCard3",
		href: "/sls-selective-laser-sintering",
	},
	{
		image: `${IMAGE_BASE}/fdm-fused-deposition-modeling-3d-printing-service.webp`,
		keyPrefix: "printingServicesOverviewCard4",
		href: "/fdm-fused-deposition-modeling",
	},
] as const;

export default function PrintingServicesWithJsPrecision() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#f5f7fa] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("printingServicesOverviewTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">
						{t("printingServicesOverviewDesc")}
					</p>
				</header>

				<div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
					{CARDS.map((card) => (
						<article
							key={card.keyPrefix}
							className="flex flex-col rounded-xl border-2 border-[#7d7d7d] bg-white shadow-sm transition-shadow duration-300 hover:shadow-md"
						>
							<div className="relative aspect-[4/2.7] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={card.image}
									alt={t(`${card.keyPrefix}Alt`)}
									fill
									className="object-cover"
									sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 25vw"
								/>
							</div>
							<div className="flex flex-1 flex-col p-4">
								<h3 className="mb-3 text-lg font-bold leading-snug text-black sm:text-xl">
									{t(`${card.keyPrefix}Title`)}
								</h3>
								<p className="mb-5 flex-1 text-sm leading-relaxed text-black">{t(`${card.keyPrefix}Desc`)}</p>
								<div className="flex items-center justify-between gap-3">
									<Link
										href="/upload"
										className="inline-flex items-center justify-center self-start rounded bg-themePrimary400 px-4 py-2.5 text-center text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751]"
									>
										{t("printingServicesOverviewGetQuote")}
									</Link>
									<Link
										href={card.href}
										className="inline-flex items-center gap-1 text-sm font-semibold text-themePrimary400 transition-colors duration-300 hover:text-[#83b751]"
									>
										{t("printingServicesOverviewLearnMore")}
										<span aria-hidden="true">↗</span>
									</Link>
								</div>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
